(function(){
    angular.module('active-update-field-action.dir', [])
        .directive('activeUpdateFieldAction', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', activeUpdateFieldAction]);

    function activeUpdateFieldAction($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout){
        return {
            scope: {},
            controller: ['$scope', function($scope){
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                //When we save a the form
                $scope.save = function(dummy){
                    const check = $scope.dataFilledCorrectly();
                    $rootScope.$emit('displayActionUpdateFieldModalError', check.errors);

                    //If form data is missing
                    if(check.result === false) {
                        if($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else{
                        $rootScope.currentJB = $rootScope.currentJB.map((i) => {
                            return i;
                        });

                        let currentNode = $rootScope.currentJB.filter((i) => {
                            if(i.id === $scope.naturalId) {
                                return i;
                            }
                        });

                        currentNode[0].data = $scope.connections.data;

                        const payload = {
                            JourneyName: $rootScope.currentJBTitle,
                            JourneyVersion: 1,
                            JourneyConfiguration: JSON.stringify($rootScope.currentJB),
                            JourneyTitle : $rootScope.currentJBTitle,
                            JourneyId: $rootScope.currentAPId,
                            NodeUpdated : JSON.stringify(currentNode[0])
                        };

                        $scope.wasSave = true;
                        canvasService
                            .updateActivatedNodes(payload)
                            .finally(() => {
                                $timeout(() => {
                                    $scope.wasSave = false;
                                }, 1000);
                            });

                        //Displays th form data
                        $scope.displayList = false;
                        $rootScope.$emit('hideActionUpdateFieldModal');
                        //Hides Error
                        $scope.displayError = false;
                    }
                };

                // validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    let res = true,
                        errorList = [];

                    $scope.connections.data.fields.map((f, index) => {
                        errorList.push({});

                        if (!f.pickedField) {
                            errorList[index].pickedField = true;
                            res = false;
                        } else {
                            errorList[index].pickedField = false;
                        }

                        if (!f.pickedList) {
                            errorList[index].pickedList = true;
                            res = false;
                        } else {
                            errorList[index].pickedList = false;
                        }
                    });

                    return {
                        result: res,
                        errors: errorList
                    };
                };

                $scope.showTipModal = () => {
                    // displays tip modal
                    $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections, true);
                };

                $scope.config = function(evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if(newTop !== $scope.connections.top || $scope.connections.left !== newLeft){
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if(!wasUpdated){
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        $rootScope.$emit('hideActionUpdateFieldModal');
                        return false;
                    }
                    //Show form menu
                    if($scope.displayList === false){
                        $scope.displayList = true;
                        $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections);
                    }else{
                        $scope.displayList = false;
                        $rootScope.$emit('hideActionUpdateFieldModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.parseDescription = function () {
                    let description = '';
                    const fieldCount = $scope.connections && $scope.connections.data && $scope.connections.data.fields.length;
                    if(fieldCount) {
                        if(fieldCount > 1) {
                            description = `${fieldCount} Fields`;
                        } else {
                            description = $scope.connections.data.fields[0].pickedFieldName
                        }
                    }

                    let fieldsDesc = '';
                    $scope.connections.data.fields.map((i) => {
                        fieldsDesc += `<tr><td>${i.pickedFieldName}</td><td>${i.updateTo}</tr>`;
                    });

                    $scope.descriptionTooltip = `<table class=contactUsageBreakdown-table><tbody>${fieldsDesc}</tbody></table>`;

                    return description;
                };

                $scope.saveEvents = function() {
                    $rootScope.$on('saveActionUpdateFieldData' + $scope.connections.id, function(evt, conn) {
                        $scope.tempConn = angular.copy($scope.connections);
                        $scope.connections = angular.copy(conn);
                        $scope.save();
                    });
                };
            }],
            link: function (scope, elem, attr) {
                //Scope data initialization
                scope.isElegibleForUpdate = true;
                scope.wasSave = false;

                //load existing
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (scope.connections){
                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.aElement;
                            return false;
                        }
                    }

                    var template = $templateCache.get('active_templates/actions/active-update-field');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';
                    scope.naturalId = helpers.getNaturalId(scope.id);

                    scope.connections = $rootScope.aElement;
                    delete $rootScope.aElement;
                    scope.isElegibleForUpdate = false;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function(evt, data) {
                        if(data) {
                            scope.numbers = data;
                        }
                    });

                    scope.saveEvents();
                }
            }
        };
    }
}());



// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/actions/active-update-field-action.js